<template>
  <div class="not-found-page">
    <div class="w-layout-blockcontainer container w-container">
      <div class="padding-6">
        <div class="layout-center">
          <div class="align-center">
            <div class="error-badge">
              <div class="error-icon">🔍</div>
              <div class="caption">Página não encontrada</div>
            </div>

            <div class="margin-top-1">
              <div class="error-code">404</div>
            </div>

            <div class="margin-top-1">
              <div class="error-heading">
                <h2 class="error-code">Oops! Esta página não existe</h2>
              </div>
            </div>

            <div class="margin-top-1">
              <div class="max-w-48">
                <div class="error-description color-text-dark-secondary">
                  A página que você está procurando pode ter sido removida, teve seu nome alterado ou está temporariamente indisponível.
                </div>
              </div>
            </div>

            <div class="margin-top-3">
              <div class="error-actions">
                <router-link to="/" class="cta-button-primary">
                  <span>Voltar ao Início</span>
                  <div class="cta-arrow">←</div>
                </router-link>
                <button @click="goBack" class="cta-button-secondary">
                  <span>Página Anterior</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="margin-top-6">
          <div class="helpful-links">
            <h3 class="">Páginas que podem interessar</h3>
            <div class="links-grid">
              <router-link to="/" class="link-card">
                <div class="link-icon">🏠</div>
                <div class="link-content">
                  <h4>Página Inicial</h4>
                  <p>Conheça o CreditFlow e nossas soluções</p>
                </div>
              </router-link>

              <router-link to="/#about" class="link-card">
                <div class="link-icon">💡</div>
                <div class="link-content">
                  <h4>Sobre a Plataforma</h4>
                  <p>Saiba mais sobre o CreditFlow</p>
                </div>
              </router-link>

              <router-link to="/#price" class="link-card">
                <div class="link-icon">💰</div>
                <div class="link-content">
                  <h4>Preços</h4>
                  <p>Conheça nossos planos e valores</p>
                </div>
              </router-link>

              <router-link to="/#contact" class="link-card">
                <div class="link-icon">📞</div>
                <div class="link-content">
                  <h4>Contato</h4>
                  <p>Entre em contato conosco</p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    }
  },
  mounted() {
    document.title = '404 - Página não encontrada | CreditFlow';
  }
}
</script>

<style scoped>
.not-found-page {
  min-height: 100vh;
  background: #1a1a1a;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.not-found-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="error-grid" width="20" height="20" patternUnits="userSpaceOnUse"><path d="M 20 0 L 0 0 0 20" fill="none" stroke="rgba(255,255,255,0.03)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23error-grid)" /></svg>');
  opacity: 0.4;
}

.error-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  padding: 16px 32px;
  border-radius: 50px;
  box-shadow: 0 8px 32px rgba(220, 53, 69, 0.3);
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
}

.error-icon {
  font-size: 24px;
  animation: pulse-icon 2s ease-in-out infinite;
}

.error-code {
  font-size: 8rem;
  font-weight: 900;
  background: linear-gradient(135deg, #007bff, #0056b3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
  margin-bottom: 1rem;
  text-shadow: 0 0 50px rgba(0, 123, 255, 0.3);
}

.error-heading h2 {
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
}

.error-description {
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

/* Action Buttons */
.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-button-primary {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  text-decoration: none;
  border-radius: 50px;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.cta-button-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(0, 123, 255, 0.4);
  text-decoration: none;
  color: white;
}

.cta-button-secondary {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: transparent;
  color: #007bff;
  border: 2px solid #007bff;
  border-radius: 50px;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.cta-button-secondary:hover {
  background: #007bff;
  color: white;
  transform: translateY(-2px);
}

.cta-arrow {
  font-size: 18px;
  font-weight: bold;
  transition: transform 0.3s ease;
}

.cta-button-primary:hover .cta-arrow {
  transform: translateX(-5px);
}

/* Helpful Links */
.helpful-links {
  text-align: center;
}

.helpful-links h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
}

.links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.link-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #2a2a2a;
  border: 1px solid #404040;
  border-radius: 15px;
  padding: 1.5rem;
  text-decoration: none;
  transition: all 0.3s ease;
  color: inherit;
}

.link-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  border-color: #007bff;
  text-decoration: none;
  color: inherit;
}

.link-icon {
  font-size: 32px;
  min-width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #007bff, #0056b3);
  border-radius: 12px;
}

.link-content {
  text-align: left;
  flex: 1;
}

.link-content h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  margin: 0 0 0.5rem 0;
}

.link-content p {
  font-size: 0.9rem;
  color: #b8b8b8;
  margin: 0;
  line-height: 1.4;
}

/* Animations */
@keyframes pulse-icon {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .error-code {
    font-size: 6rem;
  }

  .error-heading h2 {
    font-size: 2rem;
  }

  .error-description {
    font-size: 1rem;
  }

  .error-actions {
    flex-direction: column;
    align-items: center;
  }

  .cta-button-primary,
  .cta-button-secondary {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }

  .links-grid {
    grid-template-columns: 1fr;
  }

  .link-card {
    padding: 1.25rem;
  }
}

@media (max-width: 480px) {
  .error-code {
    font-size: 4rem;
  }

  .error-heading h2 {
    font-size: 1.5rem;
  }

  .error-badge {
    padding: 12px 24px;
  }

  .link-card {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .link-content {
    text-align: center;
  }
}
</style>